import React, { useState, useEffect } from 'react';
import Layout from '../components/Layout';
import api from '../services/api';
import { FaCalendarCheck, FaClock, FaUsers, FaTools, FaCamera, FaChevronLeft, FaChevronRight, FaTimes } from 'react-icons/fa';

const TIPOS_ICONE = {
  quadra: '🏟️', quiosque: '🏠', sauna: '🧖',
  churrasqueira: '🔥', salao_festas: '🎉', piscina: '🏊', area_verde: '🌳', outro: '📍'
};

const Espacos = () => {
  const [espacos, setEspacos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filtroTipo, setFiltroTipo] = useState('');
  const [reservaForm, setReservaForm] = useState(null);
  const [formData, setFormData] = useState({ titulo: '', data: '', horaInicio: '', horaFim: '', quantidadePessoas: 1, observacao: '' });
  const [msg, setMsg] = useState({ text: '', type: 'success' });
  const [carouselOpen, setCarouselOpen] = useState(false);
  const [carouselImages, setCarouselImages] = useState([]);
  const [carouselIndex, setCarouselIndex] = useState(0);

  useEffect(() => { loadEspacos(); }, []);

  const loadEspacos = async () => {
    setLoading(true);
    try {
      const res = await api.get('/espacos');
      if (res.data.success) setEspacos(res.data.data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const showMsg = (text, type = 'success') => {
    setMsg({ text, type });
    setTimeout(() => setMsg({ text: '', type: 'success' }), 4000);
  };

  const openCarousel = (imagens) => {
    setCarouselImages(imagens);
    setCarouselIndex(0);
    setCarouselOpen(true);
  };

  const prevSlide = () => setCarouselIndex(i => (i > 0 ? i - 1 : carouselImages.length - 1));
  const nextSlide = () => setCarouselIndex(i => (i < carouselImages.length - 1 ? i + 1 : 0));

  const handleReserva = async () => {
    if (!formData.titulo.trim() || !formData.data || !formData.horaInicio) return showMsg('Preencha os campos obrigatórios', 'error');
    try {
      await api.post('/reservas', { espaco: reservaForm._id, ...formData });
      showMsg('Reserva enviada! Aguarde confirmação.');
      setReservaForm(null);
      setFormData({ titulo: '', data: '', horaInicio: '', horaFim: '', quantidadePessoas: 1, observacao: '' });
    } catch (err) {
      showMsg(err.response?.data?.message || 'Erro ao reservar', 'error');
    }
  };

  const filtered = filtroTipo ? espacos.filter(e => e.tipo === filtroTipo) : espacos;
  const disponiveis = filtered.filter(e => e.status === 'disponivel' && !e.manutencao?.emManutencao && e.activo);

  const hoje = new Date().toISOString().split('T')[0];
  const tipos = [...new Set(espacos.map(e => e.tipo))];

  const cardStyle = (e) => ({
    backgroundColor: '#fff',
    borderRadius: '16px',
    padding: '20px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
    border: e.manutencao?.emManutencao ? '2px solid #f57c00' : '1px solid #edf2f7',
    opacity: e.manutencao?.emManutencao || e.status === 'inativo' ? 0.7 : 1
  });

  return (
    <Layout title="Espaços do Clube">
      <div style={{ padding: '20px', maxWidth: '1200px', margin: '0 auto' }}>

        {msg.text && (
          <div style={{ padding: '12px 16px', borderRadius: '8px', marginBottom: '16px', backgroundColor: msg.type === 'error' ? '#f8d7da' : '#d4edda', color: msg.type === 'error' ? '#721c24' : '#155724', fontFamily: 'Montserrat', fontSize: '13px' }}>
            {msg.text}
          </div>
        )}

        <div style={{ marginBottom: '20px' }}>
          <select style={{ padding: '10px 14px', borderRadius: '8px', border: '1px solid #ddd', fontSize: '14px', fontFamily: 'Montserrat' }}
            value={filtroTipo} onChange={e => setFiltroTipo(e.target.value)}>
            <option value="">Todos os espaços</option>
            {tipos.map(t => <option key={t} value={t}>{TIPOS_ICONE[t] || ''} {t.charAt(0).toUpperCase() + t.slice(1).replace('_', ' ')}</option>)}
          </select>
        </div>

        {loading ? (
          <div style={{ textAlign: 'center', padding: '40px', color: '#888', fontFamily: 'Montserrat' }}>Carregando...</div>
        ) : disponiveis.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '40px', color: '#888', fontFamily: 'Montserrat' }}>Nenhum espaço disponível no momento</div>
        ) : (
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: '16px' }}>
            {disponiveis.map(e => (
              <div key={e._id} style={cardStyle(e)}>
                <div style={{ fontSize: '32px', marginBottom: '8px' }}>{TIPOS_ICONE[e.tipo] || '📍'}</div>
                <div style={{ fontFamily: 'Montserrat', fontSize: '16px', fontWeight: '700', color: '#1A3B7D', marginBottom: '4px' }}>{e.nome}</div>
                {e.descricao && <div style={{ fontFamily: 'Montserrat', fontSize: '12px', color: '#666', marginBottom: '10px' }}>{e.descricao}</div>}

                {e.imagens && e.imagens.length > 0 && (
                  <div
                    style={{ position: 'relative', height: '140px', borderRadius: '10px', overflow: 'hidden', marginBottom: '10px', cursor: 'pointer', backgroundColor: '#f0f0f0' }}
                    onClick={() => openCarousel(e.imagens)}
                  >
                    <img
                      src={e.imagens[0]}
                      alt={e.nome}
                      style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                      onError={(ev) => { ev.target.style.display = 'none'; }}
                    />
                    {e.imagens.length > 1 && (
                      <div style={{
                        position: 'absolute', bottom: '6px', right: '6px',
                        backgroundColor: 'rgba(0,0,0,0.65)', color: 'white',
                        borderRadius: '12px', padding: '3px 8px', fontSize: '10px',
                        fontFamily: 'Montserrat', fontWeight: '700',
                        display: 'flex', alignItems: 'center', gap: '4px'
                      }}>
                        <FaCamera size={9} /> +{e.imagens.length - 1}
                      </div>
                    )}
                    <div style={{
                      position: 'absolute', top: '6px', right: '6px',
                      backgroundColor: 'rgba(26,59,125,0.85)', color: 'white',
                      borderRadius: '50%', width: '26px', height: '26px',
                      display: 'flex', alignItems: 'center', justifyContent: 'center'
                    }}>
                      <FaCamera size={11} />
                    </div>
                  </div>
                )}

                {e.horarios?.funcionamento && (
                  <div style={{ marginBottom: '8px' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '6px', fontFamily: 'Montserrat', fontSize: '11px', color: '#555', marginBottom: '4px' }}>
                      <FaClock size={12} />
                      <strong>{e.horarios.funcionamento.tipo === 'agendamento' ? 'Agendamento' : 'Uso livre'}</strong>
                    </div>
                    {e.horarios.funcionamento.diasSemana && e.horarios.funcionamento.diasSemana.length > 0 ? (
                      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(120px, 1fr))', gap: '4px' }}>
                        {e.horarios.funcionamento.diasSemana.map(d => (
                          <div key={d.dia} style={{ fontSize: '10px', padding: '3px 6px', borderRadius: '4px', backgroundColor: d.ativo ? '#e8f5e9' : '#fce4ec', color: d.ativo ? '#2e7d32' : '#c62828' }}>
                            <span style={{ textTransform: 'capitalize', fontWeight: '600' }}>{d.dia}</span>: {d.ativo ? `${d.horaAbertura}-${d.horaFechamento}` : 'Fechado'}
                          </div>
                        ))}
                      </div>
                    ) : (
                      <div style={{ fontFamily: 'Montserrat', fontSize: '11px', color: '#888' }}>Horário não definido</div>
                    )}
                    {e.horarios?.funcionamento?.feriados?.ativo && (
                      <div style={{ fontSize: '10px', padding: '4px 8px', borderRadius: '4px', backgroundColor: '#e3f2fd', color: '#1565c0', marginTop: '6px' }}>
                        Feriados: {e.horarios.funcionamento.feriados.horaAbertura} - {e.horarios.funcionamento.feriados.horaFechamento}
                      </div>
                    )}
                  </div>
                )}
                {e.capacidade > 0 && (
                  <div style={{ display: 'flex', alignItems: 'center', gap: '6px', fontFamily: 'Montserrat', fontSize: '11px', color: '#555', marginBottom: '6px' }}>
                    <FaUsers size={12} /> Capacidade: {e.capacidade} pessoas
                  </div>
                )}
                {e.local && <div style={{ fontFamily: 'Montserrat', fontSize: '11px', color: '#888', marginBottom: '8px' }}>{e.local}</div>}

                {e.preco?.tipo !== 'gratuito' && e.preco?.valor > 0 && (
                  <div style={{ fontFamily: 'Montserrat', fontSize: '13px', fontWeight: '700', color: '#c62828', marginBottom: '12px' }}>
                    R$ {e.preco.valor.toLocaleString('pt-BR', { minimumFractionDigits: 2 })} {e.preco.tipo === 'taxa_hora' ? '/hora' : ''}
                  </div>
                )}
                {e.preco?.tipo === 'gratuito' && (
                  <div style={{ fontFamily: 'Montserrat', fontSize: '12px', fontWeight: '700', color: '#2e7d32', marginBottom: '12px' }}>Gratuito</div>
                )}

                {e.regras && <div style={{ fontFamily: 'Montserrat', fontSize: '10px', color: '#888', marginBottom: '12px', fontStyle: 'italic' }}>{e.regras}</div>}

                {e.horarios?.funcionamento?.tipo === 'agendamento' && (
                  <button style={{
                    width: '100%', padding: '10px', borderRadius: '8px', border: 'none',
                    backgroundColor: '#1A3B7D', color: 'white', fontFamily: 'Montserrat',
                    fontSize: '13px', fontWeight: '600', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px'
                  }} onClick={() => { setReservaForm(e); setFormData({ titulo: '', data: hoje, horaInicio: '', horaFim: '', quantidadePessoas: 1, observacao: '' }); }}>
                    <FaCalendarCheck size={14} /> Reservar
                  </button>
                )}
                {e.horarios?.funcionamento?.tipo === 'livre' && (
                  <div style={{ textAlign: 'center', fontFamily: 'Montserrat', fontSize: '12px', color: '#2e7d32', fontWeight: '600', padding: '10px', backgroundColor: '#e8f5e9', borderRadius: '8px' }}>
                    Uso livre - disponível agora
                  </div>
                )}
              </div>
            ))}
          </div>
        )}

        {/* Em manutenção */}
        {filtered.filter(e => e.manutencao?.emManutencao).length > 0 && (
          <>
            <div style={{ fontFamily: 'Montserrat', fontSize: '14px', fontWeight: '700', color: '#f57c00', marginTop: '24px', marginBottom: '12px', display: 'flex', alignItems: 'center', gap: '8px' }}>
              <FaTools size={16} /> Em Manutenção
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: '16px' }}>
              {filtered.filter(e => e.manutencao?.emManutencao).map(e => (
                <div key={e._id} style={cardStyle(e)}>
                  <div style={{ fontSize: '32px', marginBottom: '8px' }}>{TIPOS_ICONE[e.tipo] || '📍'}</div>
                  <div style={{ fontFamily: 'Montserrat', fontSize: '16px', fontWeight: '700', color: '#f57c00', marginBottom: '4px' }}>{e.nome}</div>
                  {e.imagens && e.imagens.length > 0 && (
                    <div
                      style={{ position: 'relative', height: '120px', borderRadius: '10px', overflow: 'hidden', marginBottom: '10px', cursor: 'pointer', backgroundColor: '#f0f0f0' }}
                      onClick={() => openCarousel(e.imagens)}
                    >
                      <img src={e.imagens[0]} alt={e.nome} style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                        onError={(ev) => { ev.target.style.display = 'none'; }} />
                      {e.imagens.length > 1 && (
                        <div style={{ position: 'absolute', bottom: '6px', right: '6px', backgroundColor: 'rgba(0,0,0,0.65)', color: 'white', borderRadius: '12px', padding: '3px 8px', fontSize: '10px', fontFamily: 'Montserrat', fontWeight: '700', display: 'flex', alignItems: 'center', gap: '4px' }}>
                          <FaCamera size={9} /> +{e.imagens.length - 1}
                        </div>
                      )}
                    </div>
                  )}
                  <div style={{ backgroundColor: '#fff3e0', borderRadius: '8px', padding: '8px 10px', fontFamily: 'Montserrat', fontSize: '11px', color: '#e65100' }}>
                    <strong>Manutenção:</strong> {e.manutencao.motivo || 'Em manutenção'}
                    {e.manutencao.previsaoFim && ` • Previsão: ${new Date(e.manutencao.previsaoFim).toLocaleDateString('pt-BR')}`}
                  </div>
                </div>
              ))}
            </div>
          </>
        )}

        {reservaForm && (
          <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
            <div style={{ backgroundColor: '#fff', borderRadius: '16px', padding: '24px', width: '90%', maxWidth: '450px', maxHeight: '90vh', overflowY: 'auto' }}>
              <h3 style={{ fontFamily: 'Montserrat', fontSize: '16px', fontWeight: '700', color: '#1A3B7D', marginBottom: '6px' }}>
                Reservar: {reservaForm.nome}
              </h3>
              <p style={{ fontFamily: 'Montserrat', fontSize: '11px', color: '#888', marginBottom: '20px' }}>
                {reservaForm.horarios?.funcionamento?.tipo === 'agendamento' ? 'Agendamento obrigatório' : 'Uso livre'}
              </p>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                <div>
                  <div style={{ fontFamily: 'Montserrat', fontSize: '12px', fontWeight: '600', color: '#555', marginBottom: '4px' }}>Título do evento *</div>
                  <input style={{ width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #ddd', fontSize: '13px', fontFamily: 'Montserrat', boxSizing: 'border-box' }}
                    value={formData.titulo} onChange={e => setFormData(p => ({ ...p, titulo: e.target.value }))} placeholder="Ex: Aniversário do João" />
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
                  <div>
                    <div style={{ fontFamily: 'Montserrat', fontSize: '12px', fontWeight: '600', color: '#555', marginBottom: '4px' }}>Data *</div>
                    <input style={{ width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #ddd', fontSize: '13px', fontFamily: 'Montserrat', boxSizing: 'border-box' }}
                      type="date" value={formData.data} min={hoje} onChange={e => setFormData(p => ({ ...p, data: e.target.value }))} />
                  </div>
                  <div>
                    <div style={{ fontFamily: 'Montserrat', fontSize: '12px', fontWeight: '600', color: '#555', marginBottom: '4px' }}>Pessoas</div>
                    <input style={{ width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #ddd', fontSize: '13px', fontFamily: 'Montserrat', boxSizing: 'border-box' }}
                      type="number" value={formData.quantidadePessoas} min="1" max={reservaForm.capacidade || 100}
                      onChange={e => setFormData(p => ({ ...p, quantidadePessoas: parseInt(e.target.value) || 1 }))} />
                  </div>
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
                  <div>
                    <div style={{ fontFamily: 'Montserrat', fontSize: '12px', fontWeight: '600', color: '#555', marginBottom: '4px' }}>Hora início *</div>
                    <input style={{ width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #ddd', fontSize: '13px', fontFamily: 'Montserrat', boxSizing: 'border-box' }}
                      type="time" value={formData.horaInicio} onChange={e => setFormData(p => ({ ...p, horaInicio: e.target.value }))} />
                  </div>
                  <div>
                    <div style={{ fontFamily: 'Montserrat', fontSize: '12px', fontWeight: '600', color: '#555', marginBottom: '4px' }}>Hora fim</div>
                    <input style={{ width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #ddd', fontSize: '13px', fontFamily: 'Montserrat', boxSizing: 'border-box' }}
                      type="time" value={formData.horaFim} onChange={e => setFormData(p => ({ ...p, horaFim: e.target.value }))} />
                  </div>
                </div>
                <div>
                  <div style={{ fontFamily: 'Montserrat', fontSize: '12px', fontWeight: '600', color: '#555', marginBottom: '4px' }}>Observação</div>
                  <textarea style={{ width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #ddd', fontSize: '13px', fontFamily: 'Montserrat', height: '60px', resize: 'vertical', boxSizing: 'border-box' }}
                    value={formData.observacao} onChange={e => setFormData(p => ({ ...p, observacao: e.target.value }))} placeholder="Alguma observação?" />
                </div>
              </div>
              <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end', marginTop: '20px' }}>
                <button style={{ padding: '10px 16px', borderRadius: '8px', border: 'none', backgroundColor: '#e0e0e0', color: '#333', fontFamily: 'Montserrat', fontSize: '13px', fontWeight: '600', cursor: 'pointer' }}
                  onClick={() => setReservaForm(null)}>Cancelar</button>
                <button style={{ padding: '10px 16px', borderRadius: '8px', border: 'none', backgroundColor: '#1A3B7D', color: 'white', fontFamily: 'Montserrat', fontSize: '13px', fontWeight: '600', cursor: 'pointer' }}
                  onClick={handleReserva}>Enviar Solicitação</button>
              </div>
            </div>
          </div>
        )}

        {carouselOpen && (
          <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.92)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 2000 }}>
            <button onClick={() => setCarouselOpen(false)} style={{ position: 'absolute', top: '16px', right: '16px', background: 'transparent', border: 'none', color: 'white', cursor: 'pointer', fontSize: '28px', zIndex: 10 }}>
              <FaTimes />
            </button>
            {carouselImages.length > 1 && (
              <>
                <button onClick={prevSlide} style={{ position: 'absolute', left: '12px', background: 'rgba(255,255,255,0.15)', border: 'none', color: 'white', cursor: 'pointer', fontSize: '24px', padding: '10px', borderRadius: '50%', zIndex: 10 }}>
                  <FaChevronLeft />
                </button>
                <button onClick={nextSlide} style={{ position: 'absolute', right: '12px', background: 'rgba(255,255,255,0.15)', border: 'none', color: 'white', cursor: 'pointer', fontSize: '24px', padding: '10px', borderRadius: '50%', zIndex: 10 }}>
                  <FaChevronRight />
                </button>
              </>
            )}
            <img
              src={carouselImages[carouselIndex]}
              alt=""
              style={{ maxWidth: '92vw', maxHeight: '80vh', objectFit: 'contain', borderRadius: '10px' }}
            />
            {carouselImages.length > 1 && (
              <>
                <div style={{ position: 'absolute', bottom: '18px', display: 'flex', gap: '6px', justifyContent: 'center' }}>
                  {carouselImages.map((_, idx) => (
                    <div key={idx} style={{ width: '8px', height: '8px', borderRadius: '50%', backgroundColor: idx === carouselIndex ? 'white' : 'rgba(255,255,255,0.35)', cursor: 'pointer' }} onClick={() => setCarouselIndex(idx)} />
                  ))}
                </div>
                <div style={{ position: 'absolute', bottom: '40px', color: 'rgba(255,255,255,0.7)', fontFamily: 'Montserrat', fontSize: '12px' }}>
                  {carouselIndex + 1} / {carouselImages.length}
                </div>
              </>
            )}
          </div>
        )}

      </div>
    </Layout>
  );
};

export default Espacos;
